import Box from '@mui/material/Box';
import { withStyles } from '@material-ui/core/styles';
import Tooltip from '@material-ui/core/Tooltip';
import Typography from '@material-ui/core/Typography';
import clsx from 'clsx';
import TagType from 'components/mocules/TagType';
import styles from './styles.module.css';

const AdditionalTooltip = ({ tags, exp = null, isProductDetailNew }) => {
  const CustomizeTooltip = withStyles({
    tooltip: {
      backgroundColor: '#ffffff',
      border: '1px solid #eaeaea',
      display: 'flex',
      justifyContent: 'space-beetwen',
      flexWrap: 'wrap',
    },
    arrow: {
      '&:before': {
        border: '1px solid #eaeaea',
        backgroundColor: '#ffffff',
      },
    },
  })(Tooltip);

  const remainTagType = tags?.map((tag) => (
    <Box style={{ padding: '2px' }} key={tag}>
      <TagType item={tag} exp={exp} isProductDetailNew={isProductDetailNew} />
    </Box>
  ));

  return (
    <CustomizeTooltip title={remainTagType} disableFocusListener disableTouchListener className={clsx(styles.tag_quantity)} arrow>
      <Box className={styles.tag}>
        <Typography style={{ marginBottom: '8px' }}>...</Typography>
      </Box>
    </CustomizeTooltip>
  );
};
export default AdditionalTooltip;
